import { render, staticRenderFns } from "./QuotationModal.vue?vue&type=template&id=7bc70fe6&scoped=true&"
import script from "./QuotationModal.vue?vue&type=script&lang=js&"
export * from "./QuotationModal.vue?vue&type=script&lang=js&"
import style0 from "./QuotationModal.vue?vue&type=style&index=0&id=7bc70fe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc70fe6",
  null
  
)

export default component.exports